import { Color, MeshStandardMaterial, type Material } from "three";

import { withCustomShader } from "./customShader";
import pulsingEmissionShader from "./shaders/pulsingEmission.glsl?raw";
import type { SlotLook } from "./slotLook";

// WARN: returns `original` untouched when there is nothing to override so callers must only dispose materials that differ from it
export function materialForSlot(original: Material, look: SlotLook): Material {
  if (look.mode === "original" || !(original instanceof MeshStandardMaterial)) return original;

  if (look.mode === "emission") {
    const material = original.clone();
    material.emissive = new Color(look.color);
    material.emissiveIntensity = look.strength;
    return material;
  }

  return withCustomShader(original, pulsingEmissionShader, {
    uColor: { value: new Color(look.color) },
    uStrength: { value: look.strength }
  });
}
